import { datadogRum } from '@datadog/browser-rum';

import { TTrackerErrorContext } from './types';

import { trackEvents } from 'common/config/events';
import {
  BasicUserEvent,
  Error as TAppError,
  TrackerConfig,
  TrackerEvent,
  UserEvent,
} from 'common/types/services';

class DatadogTracker extends TrackerEvent {
  valid = (key: keyof TrackerConfig) => {
    return trackEvents.datadog.enabled && trackEvents.datadog[key];
  };

  getEnvironment = () => {
    return process.env.REACT_APP_ENV === 'production' ? 'prod' : process.env.REACT_APP_ENV;
  };

  init = () => {
    const env = this.getEnvironment();

    if (this.valid('enabled')) {
      datadogRum.init({
        trackViewsManually: true,
        applicationId: process.env.REACT_APP_DATA_DOG_APPLICATION_ID ?? '',
        clientToken: process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN ?? '',
        site: process.env.REACT_APP_DATA_DOG_URL_CLIENT,
        service: 'one-touch',
        env: env,
        version: process.env.REACT_APP_VERSION,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        sampleRate: 100,
        //set the % of the sample rate to record
        sessionReplaySampleRate: 100,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [process.env.REACT_APP_API_BASE_URL ?? ''],
      });

      datadogRum.startSessionReplayRecording();
    }
  };

  trackUser = (user: UserEvent | BasicUserEvent) => {
    if (this.valid('user')) {
      datadogRum.setUser({
        id: user.id_external,
        email: user.email,
        merchant_id: user.merchant_id,
        merchant_name: user.merchant_name,
      });
    }
  };

  trackError = (error: unknown, context?: TTrackerErrorContext) => {
    const appError = error as TAppError;
    if (this.valid('error')) {
      const errorStatus = appError.status ?? '';
      const customError = new Error(`${errorStatus} ${appError.message}`);

      datadogRum.addError(customError, {
        ...context,
        stack: appError,
      });
    }
  };
}

export default new DatadogTracker();
